import React, {ReactElement} from "react";
import {ButtonBase, Card, Grid} from "@mui/material";
import {PageElement} from "@/smilebook-shared/types";

export function SidebarContentBackground(props: {
  selectedElement: PageElement,
  colors: string[],
  selectedColor: string,
  setSelectedColor: (color: string) => void
}): ReactElement {
  return <Grid container spacing={2}>
    {props.colors.map(value => <Grid item xs={4}>
      <Card style={{width: "100%"}}>
        <ButtonBase
          onClick={() => {
            props.setSelectedColor(value);
          }}
          style={{
            width: "100%",
            aspectRatio: 3 / 2,
            background: value,
          }}>
        </ButtonBase>
      </Card>
    </Grid>)}
  </Grid>;
}